export enum LegalEntityEnum {
  ON_AG = 'onag',
  ON_AU = 'onau',
  ON_BR = 'onbr',
  ON_CA = 'onca',
  ON_CH = 'onch',
  ON_CN = 'oncn',
  ON_HK = 'onhk',
  ON_JP = 'onjp',
  ON_KR = 'onkr',
  ON_MX = 'onmx',
  ON_UK = 'onuk',
  ON_US = 'onus',
}
